/* ---- DOM manipulation ---- */
const currentTradeinItem = JSON.parse(sessionStorage.getItem("currentTradeinItem"));
const tradeinPromoDetails = JSON.parse(sessionStorage.getItem("tradeinPromoDetails"));
if (!currentTradeinItem) {
  window.location = `${Shopify.routes.root}pages/trade-in-search-2`;
}
const eligibilityTemplateWrapper = document.querySelector('.trade-in-eligibility'); 
const itemName = document.getElementById('trade-in-eligibility__item-name');
const itemBrand = document.getElementById('trade-in-eligibility__item-brand-name');
const itemStyle = document.querySelector('.trade-in-eligibility__item-style');
const itemStyleNumber = document.getElementById('trade-in-eligibility__item-style-number');
const itemImageMobile = document.getElementById('trade-in-eligibility__item-image__mobile');
const itemImageDesktop = document.getElementById('trade-in-eligibility__item-image__desktop');
const content = document.querySelector('.trade-in-eligibility__content')
const confirmButton = document.getElementById('trade-in-eligibility__confirm-button');
const eligibleOption = document.getElementById('trade-in-eligibility__eligible-option');
const ineligibleOption = document.getElementById('trade-in-eligibility__ineligible-option');
const estimatedValue = document.getElementById('trade-in-eligibility__estimated-value');
const estimatedPrepromoValue = document.getElementById('trade-in-eligibility__estimated-prepromo-value');
const promotionText = document.querySelector('.trade-in-eligibility__promotion-text');
const estimatedValueLabel = document.getElementById('trade-in-eligibility__estimated-value-label');
const colorVariantSlider = document.querySelector('.trade-in-eligibility__color-variant-slider');
const currentColor = document.querySelector('.trade-in-eligibility__current-color');
const currentColorLabel = document.querySelector('.trade-in-eligibility__current-color-label');
const colorDisclaimer = document.querySelector('.trade-in-eligibility__color-disclaimer');
const modalTermsAndConditionsContent = document.querySelector('.modal-terms-and-conditions__content');

const {
  isUnknown,
  departmentDisplay,
  categoryDisplay,
  subcategoryDisplay,
  catalogItemTitle,
  parentSku,
  colorVariants,
  submittedUnknownItemConditions,
  conditionValues,
  catalogItemBrand,
} = currentTradeinItem;

const COLOR_VARIANT_SLIDER_DESKTOP_COLS = 7;
const COLOR_VARIANT_SLIDER_MOBILE_COLS = 5;
let leftMostSlideIndex = 0;
let slidesToMove = window.screen.width <= 1144 ? COLOR_VARIANT_SLIDER_MOBILE_COLS : COLOR_VARIANT_SLIDER_DESKTOP_COLS;
slidesToMove--;
const isChrome = /Chrome/.test(navigator.userAgent);


const setDisplayImage = (src) => {
  itemImageMobile.src = src;
  itemImageMobile.setAttribute('onerror',`this.onerror=null;this.src='${localStorage.getItem('cameraShyImageUrl')}'`);

  itemImageDesktop.src = src;
  itemImageDesktop.setAttribute('onerror',`this.onerror=null;this.src='${localStorage.getItem('cameraShyImageUrl')}'`);

}

if (isUnknown) {
  eligibilityTemplateWrapper.classList.add('trade-in-eligibility-unknown');
  itemName.textContent = `${departmentDisplay} ${categoryDisplay} ${
    subcategoryDisplay ? `- ${subcategoryDisplay}` : ''
  }`;
  itemStyle.classList.add('hidden');
  itemImageMobile.classList.add('hidden');
  itemImageDesktop.classList.add('hidden');
  if (TRADE_IN_ELIGIBILITY_CONFIG.useColorSlider) {
    currentColorLabel.classList.add('hidden');
    colorDisclaimer.classList.add('hidden');
  }
  content.firstElementChild.style.display = "none";
  content.lastElementChild.style.width = "100%";
} else {
  itemName.textContent = catalogItemTitle;
  itemStyleNumber.textContent = parentSku;

  if (itemBrand) {
    itemBrand.textContent = catalogItemBrand || '';
  }
}

setDisplayImage(currentTradeinItem.itemImageUrl || localStorage.getItem('cameraShyImageUrl'));

if (TRADE_IN_ELIGIBILITY_CONFIG.useColorSlider) {
  currentColor.textContent = catalogItemTitle;
}

if (tradeinPromoDetails) {
  modalTermsAndConditionsContent.textContent = tradeinPromoDetails.tradeinPromoDetails?.termsAndConditions;
}

/* ---- Functions ---- */
function estimateGradeAndTradeinValue() {
  const isEligible = !ineligibleOption.checked;
  const recommendedGrade = isEligible ? 'GRADE_A' : 'GRADE_F';
  const {
    tradeinValue,
    displayTradeinValue,
  } = (isUnknown ? submittedUnknownItemConditions : conditionValues).find(
    condition => condition.condition.name === recommendedGrade,
  ) || {};
  return {
    recommendedGrade,
    tradeinValue: tradeinValue || 0,
    displayTradeinValue: displayTradeinValue || 0,
  };
}

async function submitTradeinEligibility() {
  const {
    recommendedGrade,
    tradeinValue,
    displayTradeinValue,
  } = estimateGradeAndTradeinValue();

  const isConditionGradingEnabled = !ineligibleOption.checked && (
    isUnknown ?
      TRADE_IN_ELIGIBILITY_CONFIG.isConditionGradingEnabledForUnknowns :
      TRADE_IN_ELIGIBILITY_CONFIG.isConditionGradingEnabledForKnowns
  );

  updateCurrentTradeinItem({
    recommendedGrade,
    tradeinValue,
    displayTradeinValue,
    isConditionGradingEnabled,
  });

  if (isConditionGradingEnabled) {
    window.location = `${Shopify.routes.root}pages/trade-in-condition-grading`;
    return;
  }

  if (TRADE_IN_ELIGIBILITY_CONFIG.isTradeInMoreQuestionsEnabled) {
    window.location = `${Shopify.routes.root}pages/trade-in-more-questions`;
    return;
  }

  return await addItemAndRedirectToCart();
};

function selectOption() {
  estimatedValueLabel.classList.remove('hidden');
  const {
    tradeinValue,
    displayTradeinValue,
  } = estimateGradeAndTradeinValue();

  if (tradeinValue !== displayTradeinValue) {
    estimatedPrepromoValue.textContent = formatCurrency(displayTradeinValue);
    estimatedPrepromoValue.classList.remove('hidden');
    promotionText.classList.remove('hidden');
    estimatedValueLabel.firstElementChild.style.setProperty('font-weight', '600', 'important');
  } else {
    estimatedPrepromoValue.classList.add('hidden');
    promotionText.classList.add('hidden');
    estimatedValueLabel.firstElementChild.style.removeProperty('font-weight');
  }
  estimatedValue.textContent = formatCurrency(tradeinValue);

  confirmButton.disabled = false;
};

function setPrevAndNextButtonDisabledStates(prevButton, nextButton, carouselItemsLength) {
  prevButton.disabled = leftMostSlideIndex === 0;
  nextButton.disabled = leftMostSlideIndex + slidesToMove >= carouselItemsLength;
}

function goToPreviousSlide(prevButton, nextButton) {
 
  listSlides = document.querySelector("#Slider-Tradein-Eligibility")
  leftMostSlideIndex -= slidesToMove;
  const children = listSlides.childNodes;

  setPrevAndNextButtonDisabledStates(prevButton, nextButton, children.length );

  [...children].map((item, idx) => {
      if(idx >= leftMostSlideIndex && idx <= leftMostSlideIndex + slidesToMove) {
        item.removeAttribute("aria-hidden")
        item.style.display = "flex";
        item.querySelector("img")?.setAttribute("tabindex","0")
        if(!isChrome) {
          item.setAttribute("tabindex","0")
        }
      } else {
        item.setAttribute("aria-hidden","true")
        item.style.display = "none";
      }
  });

  listSlides.scrollTo({
    left: 0,
    behavior: 'smooth'
  });
}

function goToNextSlide(prevButton, nextButton) {
  listSlides = document.querySelector("#Slider-Tradein-Eligibility");
  const children = listSlides.childNodes;

  leftMostSlideIndex += slidesToMove;
  setPrevAndNextButtonDisabledStates(prevButton, nextButton, children.length );
  const residualItems = (children.length-1) % slidesToMove;
  [...children].map((item, idx) => {
      if(idx >= leftMostSlideIndex && idx <= leftMostSlideIndex+slidesToMove) {
        item.removeAttribute("aria-hidden")
        item.style.display = "flex";
        item.querySelector("img")?.setAttribute("tabindex","0")
        if(!isChrome) {
          item.setAttribute("tabindex","0")
        }
        if(residualItems < COLOR_VARIANT_SLIDER_MOBILE_COLS && idx  >= children.length - (residualItems+1)) {
          item.style.flexGrow = 0;
          item.style.width = "auto";
        }
      } else {
        item.setAttribute("aria-hidden","true")
        item.style.display = "none";
      }
  });

  listSlides.scrollTo({
    left: 0,
    behavior: 'smooth'
  });

}

function selectColor (imageElement, imageSrc,  color) {
  const { displayName } = color;
  const imageUrl = imageSrc || localStorage.getItem('cameraShyImageUrl');
  setDisplayImage(imageUrl);
  setActiveColor(imageElement, displayName);
  updateCurrentTradeinItem({ colorCode: color.code, itemImageUrl: imageUrl });
}

function setActiveColor (imageElement, displayName) {
  const activeColor = document.querySelector('.active-slide');
  if (activeColor) {
    activeColor.classList.remove('active-slide')
  };
  imageElement.classList.add('active-slide');
  currentColor.textContent = displayName;
}

function updateCurrentTradeinItem(patch) {
  Object.entries(patch).forEach(([key, value]) => {
    currentTradeinItem[key] = value;
  });
  sessionStorage.setItem('currentTradeinItem', JSON.stringify(currentTradeinItem));
};

function colorMapper ({color, slider, index, alignSliderContentLeftOnDesktop}) {
  const sliderItem = document.createElement('li');
  sliderItem.classList.add('grid__item', 'slider__slide');
  sliderItem.setAttribute('tabindex',-1);
  sliderItem.style.display= "none";


  if (alignSliderContentLeftOnDesktop) {
    sliderItem.classList.add('align_left_desktop');
  }
  sliderItem.id = `Slide-${index}`;
  const imageElement = document.createElement('img');
  const imageSrc = color.url?.length ? color.url : localStorage.getItem('cameraShyImageUrl');
  if (!currentTradeinItem.colorCode) {
    if (index === 0) {
      updateCurrentTradeinItem({ colorCode: color.code, itemImageUrl: imageSrc });
      setActiveColor(imageElement, color.displayName);
      setDisplayImage(imageSrc);
    }
  } else if (currentTradeinItem.colorCode === color.code) {
    setActiveColor(imageElement, color.displayName);
  }
  const { altErrorImageMessage } = window?.altCameraShyMessage;
  const  { altKnownImageMessage } = window?.altImageMessage;
  if (color.url) {
    const normalizeImageUrl = normalizeUrl(color.url, {width: '200', height: '200'});

    imageElement.src = normalizeImageUrl;
    imageElement.alt = altKnownImageMessage;
  } else {
    imageElement.src = localStorage.getItem('cameraShyImageUrl');
    imageElement.alt = altErrorImageMessage;
  }

  fallbackToCameraShyImage(imageElement,altErrorImageMessage);
  imageElement.setAttribute("aria-hidden","true")

  sliderItem.addEventListener('click', (event) => selectColor(imageElement ,imageSrc, color));
  sliderItem.appendChild(imageElement);
  
  slider.appendChild(sliderItem);
  return sliderItem;
};

if (TRADE_IN_ELIGIBILITY_CONFIG.useColorSlider && colorVariants && colorVariants.length > 0) {
  const slider = document.createElement('ul');
  const alignSliderContentLeftOnDesktop = colorVariants.length < COLOR_VARIANT_SLIDER_DESKTOP_COLS;
  slider.id = 'Slider-Tradein-Eligibility';
  slider.style.width = "100%";
  slider.classList.add(
    'grid',
    'slider--all-sizes',
    `grid--${COLOR_VARIANT_SLIDER_DESKTOP_COLS}-col-desktop`,
    'slider',
    'slider--desktop',
    'slider--tablet',
    `grid--${COLOR_VARIANT_SLIDER_MOBILE_COLS}-col-mobile`,
  );
  if (alignSliderContentLeftOnDesktop) {
    slider.classList.add('full-width');
  }
  const sliderItems = colorVariants.map((color, index) => colorMapper({color, slider, index, alignSliderContentLeftOnDesktop}));
  const sliderButtonsSide = document.createElement('div');
  sliderButtonsSide.classList.add('slider-buttons-sides', 'no-js-hidden');
  const prevButton = document.createElement('button');
  prevButton.setAttribute('type', 'button');
  prevButton.classList.add('slider-button', 'slider-button--prev', 'nobutton');
  prevButton.setAttribute('name', 'previous');
  const iconArrowLeft = document.createElement('div');
  iconArrowLeft.classList.add('icon', 'icon-arrow-left');
  iconArrowLeft.setAttribute('aria-hidden', true);
  iconArrowLeft.setAttribute('focusable', false);
  iconArrowLeft.appendChild(document.createElement('div'));
  prevButton.appendChild(iconArrowLeft);
  const nextButton = document.createElement('button');
  nextButton.setAttribute('type', 'button');
  nextButton.classList.add('slider-button', 'slider-button--next', 'nobutton');
  nextButton.setAttribute('name', 'next');
  const iconArrowRight = document.createElement('div');
  iconArrowRight.classList.add('icon', 'icon-caret-right');
  iconArrowRight.setAttribute('aria-hidden', true);
  iconArrowRight.setAttribute('focusable', false);
  iconArrowRight.appendChild(document.createElement('div'));
  nextButton.appendChild(iconArrowRight);
  sliderButtonsSide.appendChild(prevButton);
  sliderButtonsSide.appendChild(nextButton);

  prevButton.disabled = true;
  nextButton.addEventListener('click', () => goToNextSlide(prevButton,nextButton));
  prevButton.addEventListener('click', () => goToPreviousSlide(prevButton,nextButton));


  const sliderComponent = new SliderComponent({
    slider,
    sliderItems,
  });

  sliderComponent.appendChild(slider);
   if (sliderItems.length > slidesToMove) {
    sliderComponent.appendChild(prevButton);
    sliderComponent.appendChild(slider);
    sliderComponent.appendChild(nextButton);
  } else {
    sliderComponent.appendChild(slider);
  }
  colorVariantSlider.appendChild(sliderComponent);
  showAndHideVisibleSlides(sliderComponent);
}

function showAndHideVisibleSlides(sliderComponent) {
  listSlides = document.querySelector("#Slider-Tradein-Eligibility")
  parent = document.querySelector(".trade-in-details-wrapper")
  

  const children = listSlides.childNodes;
  [...children].map(function(item, idx){
      if(idx <= slidesToMove) {
        item.setAttribute("aria-hidden","false")

        item.setAttribute("data-acsb-clickable","true")
        item.style.display = "flex";
        
      } else {
        item.setAttribute("aria-hidden","true")
        item.setAttribute("data-acsb-clickable","false")
        item.style.display = "none";
      }
  })
}

/* ---- Event Listeners ---- */
confirmButton.addEventListener('click', submitTradeinEligibility);
eligibleOption.addEventListener('click', selectOption);
ineligibleOption.addEventListener('click', selectOption);
